import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Orientation, FormContainerKind } from '@sb/library/base';
import { FormFieldBaseComponent } from '../../form-field-base.component';
import { FormFieldRadioCardComponent } from '../form-field-radio-card.component';

@Component({
    selector: 'lib-radio-card-group',
    templateUrl: './form-field-radio-card-group.component.html',
    styleUrls: ['./form-field-radio-card-group.component.scss']
})
export class FormFieldRadioCardGroupComponent<T> extends FormFieldBaseComponent<T, FormControl<T>> implements AfterContentInit, OnInit {

    @ContentChildren(FormFieldRadioCardComponent) itemQueryList!: QueryList<FormFieldRadioCardComponent<T>>;

    @Output() cardClicked: EventEmitter<T> = new EventEmitter();

    @Input() orientation: Orientation = Orientation.Horizontal;
    @Input() showRadioButton: boolean = false;
    @Input()
    set disableCards(value: boolean) {
        if (value) {
            this.itemQueryList.forEach(item => {
                item.disabled = true;
            })
        }
    }
    @Input()
    override set isReadOnly(value: boolean) {
        this.itemQueryList.forEach(item => {
            item.isReadOnly = value;
        });
    }

    constructor() {
        super();

        this.viewControl = new FormControl<T>(null as any, {nonNullable: true});
    }

    override ngOnInit() {
        super.ngOnInit();

        this.viewControl.setValue(this.formControl.value);
    }

    ChangeEvent() {
        this.SetFormControlValue(this.viewControl.value);

        super.OnBlur();
    }

    ngAfterContentInit(): void {
        this.PrepareCards();
        this._subscriptions.push(this.itemQueryList.changes.subscribe(() => this.PrepareCards()));
    }

    private _radioCards = new Set<FormFieldRadioCardComponent<T>>();

    private PrepareCards(): void {
        this.itemQueryList.forEach(item => {
            if (this._radioCards.has(item)) {
                return;
            }
            this._radioCards.add(item);
            item.showRadioButton = this.showRadioButton;
            this._subscriptions.push(item.clicked.subscribe(() => {
                const selectedValue: T = item.value;
                this.viewControl.setValue(selectedValue);
                this.SetFormControlValue(selectedValue);
                this.cardClicked.emit(selectedValue);
                this.itemQueryList.forEach(it => {
                    it.cardClicked = (it.value === selectedValue);
                });
            }));
        });
    }

    override setDisabledState(state: boolean): void {
        super.setDisabledState(state);
        this.itemQueryList?.forEach(item => {
            item.disabled = state;
        })
    }
}
